import AppIconLogo from './AppIconLogo'

export default AppIconLogo
